import { useState } from 'react';
import { initialFilters } from '../state/initial-state';
import { CountryProfileFilters } from '../types';

export const useCountryProfileFilters = (
    userInitialFilters: Partial<CountryProfileFilters> = {}
) => {
    const [filters, changeFilters] = useState<CountryProfileFilters>({
        ...initialFilters,
        ...userInitialFilters
    });

    const changeFiltersFunction = (
        changes: Partial<CountryProfileFilters>
    ) => changeFilters({
        ...filters,
        ...changes
    });

    const restoreFilters = () => changeFilters({
        ...initialFilters
    });

    return [
        filters,
        changeFiltersFunction,
        restoreFilters
    ] as [
        typeof filters,
        typeof changeFiltersFunction,
        typeof restoreFilters
    ];
};
